import React, { useRef, useState } from "react";
import { Select, Form } from "antd";
import { filter, reverse } from "lodash";
import { PersonPinCircleTwoTone } from "@material-ui/icons";

import countryList from "./countryList";
import InputStyles from "./styles/InputStyles";

const CountrySelect = ({
  classWidth = "",
  name = "country",
  onlySearchEngine = false,
}) => {
  const countryRef = useRef(null);
  const [activeInput, setActiveInput] = useState("");

  const countryOptions = countryList.map((country) => {
    return (
      <Select.Option value={country.value} key={country.value}>
        {country.text}
      </Select.Option>
    );
  });

  const countrySearchEngineOptions = reverse(
    filter(countryList, (country) => {
      return country.searchEngine;
    })
  ).map((country) => {
    return (
      <Select.Option value={country.value} key={country.value}>
        {country.text}
      </Select.Option>
    );
  });

  function handleChange(value) {
    countryRef.current.blur();
  }
  return (
    <InputStyles>
      <Form.Item name={name} className={`mb-1 mr-0 ${classWidth}`}>
        <Select
          mode="multiple"
          placeholder={
            <>
              <PersonPinCircleTwoTone className="mr-1 inputIcon" /> Select
              Country
            </>
          }
          allowClear
          ref={countryRef}
          onChange={handleChange}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
              0 ||
            option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          className={`select ${activeInput === "country" && "activeSelect"}`}
          onFocus={() => {
            setActiveInput("country");
          }}
          onBlur={() => setActiveInput("")}
        >
          {onlySearchEngine ? countrySearchEngineOptions : countryOptions}
        </Select>
      </Form.Item>
    </InputStyles>
  );
};

export default CountrySelect;
